// extracted by mini-css-extract-plugin
module.exports = {"squadsTeamCard":"style_squadsTeamCard__T_drU","icon":"style_icon__nlIB6","title":"style_title__ELxVk","teamHead":"style_teamHead__ethm5","activeTeam":"style_activeTeam__h4wbe"};